export function shortText(name: string | undefined, begin: number, end: number): string {
    if (typeof name !== 'string') {
        return '';
    }

    if (name.length <= begin + end) {
        return name;
    }

    if (end === 0) {
        return `${name.slice(0, begin)}…`;
    }

    return `${name.slice(0, begin)}…${name.slice(-1 * end)}`;
}
